/* jshint esversion: 8 */
define([
  "computeResource/collections/collection"
], function (
  Collection
) {

  class ParallelServerCollection extends Collection {

    constructor (args) {
      super(args);
    }

  }

  return ParallelServerCollection;
});
